import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/icons/CloseModal.svg'


const _hoisted_1 = { class: "editSensor" }
const _hoisted_2 = { class: "editSensor__header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "editSensor__columns" }
const _hoisted_5 = { class: "editSensor__column" }
const _hoisted_6 = { class: "editSensor__column" }
const _hoisted_7 = { class: "infoSensor editSensor__color" }
const _hoisted_8 = { class: "editSensor__color-label" }
const _hoisted_9 = { class: "editSensor__color-row" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "infoSensor editSensor__type" }
const _hoisted_12 = { class: "infoSensor" }
const _hoisted_13 = { class: "infoSensor" }
const _hoisted_14 = { class: "editSensor__buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Input = _resolveComponent("Input")!
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.showModalEditSensor)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 1,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('closeModal')))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('editSensor')), 1),
                _createElementVNode("img", {
                  class: "editSensor__header-img",
                  src: _imports_0,
                  alt: "Close Modal",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeModal')))
                })
              ]),
              _createVNode(_component_FormKit, {
                id: "editSensor-form",
                modelValue: _ctx.formData,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData) = $event)),
                type: "form",
                actions: false,
                onSubmit: _ctx.submitHandler
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoSensor, (el, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "infoSensor"
                        }, [
                          _createVNode(_component_Input, {
                            type: el.type,
                            name: el.name,
                            label: _ctx.$t(el.label),
                            disabled: el.name === 'sn' || el.name === 'id'
                          }, null, 8, ["type", "name", "label", "disabled"])
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('colorLabel')), 1),
                        _createElementVNode("div", _hoisted_9, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.color) = $event)),
                            type: "text",
                            class: "editSensor__color-text",
                            placeholder: "#000000"
                          }, null, 512), [
                            [_vModelText, _ctx.formData.color]
                          ]),
                          _createElementVNode("input", {
                            value: _ctx.colorPickerValue,
                            type: "color",
                            class: "editSensor__color-picker",
                            onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.color = $event.target.value))
                          }, null, 40, _hoisted_10)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_FormKit, {
                          modelValue: _ctx.formData.type,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.type) = $event)),
                          type: "select",
                          name: "type",
                          label: _ctx.$t('sensorType'),
                          options: _ctx.sensorTypeOptions
                        }, null, 8, ["modelValue", "label", "options"])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_Input, {
                          type: "number",
                          name: "max",
                          label: _ctx.$t('maxUpperCase'),
                          disabled: _ctx.isTempLocked
                        }, null, 8, ["label", "disabled"])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_Input, {
                          type: "number",
                          name: "min",
                          label: _ctx.$t('minUpperCase'),
                          disabled: _ctx.isTempLocked
                        }, null, 8, ["label", "disabled"])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "onSubmit"]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_Button, {
                  variant: "filled",
                  title: _ctx.$t('save'),
                  onClick: _ctx.editSensor
                }, null, 8, ["title", "onClick"]),
                _createVNode(_component_Button, {
                  variant: "bordered",
                  title: _ctx.$t('cancel'),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('closeModal')))
                }, null, 8, ["title"])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}